import { render, staticRenderFns } from "./SettingManagerial.vue?vue&type=template&id=59ffb5e6&scoped=true"
import script from "./SettingManagerial.vue?vue&type=script&lang=js"
export * from "./SettingManagerial.vue?vue&type=script&lang=js"
import style0 from "./SettingManagerial.vue?vue&type=style&index=0&id=59ffb5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ffb5e6",
  null
  
)

export default component.exports